import Vue from 'vue'
import axios from 'axios'
import Toasted from 'vue-toasted'
import Viewer from 'v-viewer'
import Vuetable from './table/Vuetable.vue'
import App from './App.vue'
import router from './router'
import auth from './services/Auth'
import * as filters from './filters'

import 'viewerjs/dist/viewer.css'
require('semantic-ui-css/semantic.min.css')
require('semantic-ui-css/semantic.min.js')

Vue.config.productionTip = false

Vue.use(Vuetable)

Vue.use(Viewer, {
  defaultOptions: {
    navbar: false,
    rotatable: false,
    scalable: false,
    transition: false,
  }
})

Vue.use(Toasted, {
  theme: 'outline',
  position: 'top-right',
  duration: 5000
})

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

axios.interceptors.request.use(function (config) {
  if (auth.getAccessToken()) {
    config.headers.common['X-ACCESS-TOKEN'] = auth.getAccessToken()
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response && error.response.status === 401) {
    auth.logout()
  }
  return Promise.reject(error.response.data)
})

auth.checkAuth()

router.beforeEach((to, from, next) => {
  if (to.meta.admin && !auth.isAdmin()) {
    next('/')
  } else if (to.meta.auth && !auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (to.meta.guest && auth.loggedIn()) {
    next('/')
  } else {
    next()
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
